import { dateFormatter } from '@components/components/CmsComponents/helpers';
import styles from '@components/components/CmsComponents/components/CmsFileList/CmsFileList.module.scss';
import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import {
  Card,
  CardBody,
  Content,
  FontAwesomeProIcon,
  Heading,
  Link,
  getHeadingTag,
} from '@wienenergiegithub/ui-next';

const Item = ({
  headingLevel = 3,
  title,
  text,
  url,
  type = 'pdf',
  validFrom,
  newTab,
  isCard,
}) => {
  const children = (
    <Link
      className={styles.linkContainer}
      rel="noopener noreferrer"
      target="_blank"
      to={url}
    >
      <FontAwesomeProIcon
        className={styles.icon}
        icon={`file-${type}`}
        role="presentation"
        type="solid"
      />
      <div className={styles.contentWrapper}>
        {title && (
          <Heading
            as={getHeadingTag(headingLevel)}
            className={styles.title}
            size="h3"
          >
            {title}
          </Heading>
        )}
        {!!text && (
          <Content className={styles.content} noSpacing size="md" withParser>
            {text}
          </Content>
        )}
        {validFrom && validFrom.date && (
          <Content className={styles.content} noSpacing size="md">
            Gültig ab: {dateFormatter(validFrom.date.replace(' ', 'T'))}
          </Content>
        )}
      </div>
    </Link>
  );

  return isCard ? (
    <Card
      as={Link}
      className={styles.file}
      key={url}
      target={newTab ? '_blank' : '_self'}
      to={url}
    >
      <CardBody>{children}</CardBody>
    </Card>
  ) : (
    // Fragments are required, otherwise the component won't render
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>{children}</>
  );
};

const CmsFileList = ({
  items,
  isCard,
  headingLevel = 3,
  isDownloadAccordion = false,
}) => (
  <div
    className={classNames(styles.container, {
      [styles.isDownloadAccordion]: isDownloadAccordion,
    })}
  >
    {items?.map(item => (
      <Item
        isCard={isCard}
        key={item.id}
        {...item}
        headingLevel={headingLevel}
      />
    ))}
  </div>
);

CmsFileList.propTypes = {
  headingLevel: PropTypes.number,
  isCard: PropTypes.bool,
  isDownloadAccordion: PropTypes.bool,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      text: PropTypes.string,
      validFrom: PropTypes.shape({
        date: PropTypes.string,
      }),
      url: PropTypes.string,
    }),
  ),
};

export default CmsFileList;
